import { uiStore } from '@/stores/ui.store';
import { userStore } from '@/stores/user.store';

export const arenaApis = {
  useSelectedModes: () => uiStore.arenaSelectedModes,
  setSelectedMode: (modes: string[]) => uiStore.setArenaSelectedModes(modes),
  useUnselectMode: () => {
    const unselectMode = (mode: string) => {
      uiStore.setArenaSelectedModes(
        uiStore.arenaSelectedModes.filter((m) => m !== mode)
      );
    };

    return unselectMode;
  },
  useAvailableModes: () => userStore.user?.allowed_chat_modes ?? [],
  useResetSelectedModes: () => {
    uiStore.setArenaSelectedModes([]);
  },
};
